export default __webpack_public_path__ + "static/cndf-cilium-clustermesh3-7a006c5c418f31e8974e4555a94fce9c.jpg";